module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"onlineInterviewNotPassed":"Кандидат пока не прошёл онлайн-интервью","offlineInterviewNotPassed":"Кандидат пока не прошёл очное интервью"}}')
  delete Component.options._Ctor
}
